import { types as t } from 'mobx-state-tree';

export const Language = t.enumeration('Language', ['is', 'en']);
